import React, {useState} from "react";
import { createRoot } from "react-dom/client";
import OrtComponent from "./OrtComponent";

const container = document.getElementById("baukultur-map");

if (container) {
    const root = createRoot(container);

    root.render(
        <OrtComponent />
    );
}
